import './ReviewCard.css';

function ReviewCard({ quote, source }) {
  return (
    <div className="review-card">
      <div className="review-card__quote-mark">&ldquo;</div>
      <p className="review-card__text">{quote}</p>
      <p className="review-card__source">&mdash; {source}</p>
    </div>
  );
}

export default ReviewCard;
